// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "single/assets/" + {"104":"1618361d59e70e39d241","168":"828b634e0e5a7050c538","303":"1be70103415dddc79901","411":"2eb7d2ad2d0cc330495d","619":"3be95dd42e562767bb0f","956":"08ef2e461a3417423024"}[chunkId] + "." + chunkId + ".js";
};